module.exports = __webpack_public_path__ + "icon-marker-orange.svg?e66fef6f09fd01db62c11d1b74862b55";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-marker-orange.svg
// module id = 31
// module chunks = 0